import useMediaQuery from "../../../common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";
import { type PdpPageProductData } from "~/ProductDetails/models/PdpPageProductData";
import { CURRENT_LANGUAGE } from "~/utils/constants";
import { type DetailedHTMLProps, type HTMLAttributes } from "react";

interface CalculationTabProps {
  product: PdpPageProductData;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "engineering-app": DetailedHTMLProps<
        HTMLAttributes<HTMLElement> & {
          language?: string;
          "wt-part-id"?: string;
          "bearing-designation"?: string;
        },
        HTMLElement
      >;
    }
  }
}

export const CalculationTab = (props: CalculationTabProps) => {
  const { product } = props;

  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return (
    <>
      <div className={"scha__ignore-margins " + (isDesktop ? undefined : "w-100")}>
        {product.externalProduct ? (
          <iframe
            className="scha__pdp-iframe"
            id="configuratorIframe"
            scrolling="yes"
            src={product.additionalCalculationUrl}
          ></iframe>
        ) : (
          <engineering-app
            bearing-designation={product.bearingXDesignation!}
            language={CURRENT_LANGUAGE}
          ></engineering-app>
        )}
      </div>
    </>
  );
};
